import { createGrid, forEachColumn, HEIGHT, getIndex } from '../utils';

export class WaveMode {
  constructor() {
    this.tick = 0;
    this.mathFunction = Math.random() < 0.5 ? 'sin': 'cos';
  }
  update(delta, { audioData } = {}) {
    this.scale = audioData?.volume * 2 || 0.2;
    this.tick += delta / 200;
  }
  getData() {
    const grid = createGrid();
    forEachColumn(({x}) => {
      const y = Math.ceil(Math[this.mathFunction]((x + this.tick + this.scale)) * 6 * this.scale + (HEIGHT / 2) - 1);
      if (y > -1 && y < HEIGHT) {
        grid[getIndex(x, y)] = true;
      }
    });
    return grid;
  }
}